module.exports = __webpack_public_path__ + "static/media/poster.4de71899.png";